/*
 * Copyright (C) 2024 - Potentially Ltd
 *
 * Please see distribution for license.
 */

import { MentorFeedback } from '@app/app/page-modules/admin/services/mentor-mentee/mentor-mentee-data.service';
import { Review } from '../../../shared/models';
import { ReviewCard, ReviewItem, ReviewSummaryForReviewer, SurroundingUserReview } from '../models';

export interface ReviewsStateModel {
  review: Review;
  reviewItem: ReviewItem;
  reviewCards: ReviewCard[];
  reviewSummaryForReviewer: ReviewSummaryForReviewer;
  surroundingUserReviews: SurroundingUserReview[];
  mentorFeedback: MentorFeedback;
}

export const INITIAL_STATE: ReviewsStateModel = {
  review: undefined,
  reviewItem: undefined,
  reviewCards: [],
  reviewSummaryForReviewer: undefined,
  surroundingUserReviews: [],
  mentorFeedback: undefined,
};
